const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'icons',
  tiles: {
    channel_bg: 0,
    channel_bg_flash: 1,
    icon_check: 2,
    icon_discord: 3,
    icon_ff: 4,
    icon_help: 5,
    icon_menu: 6,
    icon_pause: 7,
    icon_play: 8,
    icon_redo: 9,
    icon_sound0: 10,
    icon_sound1: 11,
    icon_sound2: 12,
    icon_step: 13,
    icon_stop: 14,
    icon_undo: 15,
    x: 16,
    x_focused: 17
  },
  uidata: {
    rects: [
      vec4(8/1024,8/128,56/1024,56/128),
      vec4(72/1024,8/128,120/1024,56/128),
      vec4(136/1024,8/128,184/1024,56/128),
      vec4(200/1024,8/128,248/1024,56/128),
      vec4(264/1024,8/128,312/1024,56/128),
      vec4(328/1024,8/128,376/1024,56/128),
      vec4(392/1024,8/128,440/1024,56/128),
      vec4(456/1024,8/128,504/1024,56/128),
      vec4(520/1024,8/128,568/1024,56/128),
      vec4(584/1024,8/128,632/1024,56/128),
      vec4(648/1024,8/128,696/1024,56/128),
      vec4(712/1024,8/128,760/1024,56/128),
      vec4(776/1024,8/128,824/1024,56/128),
      vec4(840/1024,8/128,888/1024,56/128),
      vec4(904/1024,8/128,952/1024,56/128),
      vec4(968/1024,8/128,1016/1024,56/128),
      vec4(8/1024,72/128,24/1024,88/128),
      vec4(40/1024,72/128,56/1024,88/128)
    ]
  },
  layers: undefined,
  FRAME_CHANNEL_BG: 0,
  FRAME_CHANNEL_BG_FLASH: 1,
  FRAME_ICON_CHECK: 2,
  FRAME_ICON_DISCORD: 3,
  FRAME_ICON_FF: 4,
  FRAME_ICON_HELP: 5,
  FRAME_ICON_MENU: 6,
  FRAME_ICON_PAUSE: 7,
  FRAME_ICON_PLAY: 8,
  FRAME_ICON_REDO: 9,
  FRAME_ICON_SOUND0: 10,
  FRAME_ICON_SOUND1: 11,
  FRAME_ICON_SOUND2: 12,
  FRAME_ICON_STEP: 13,
  FRAME_ICON_STOP: 14,
  FRAME_ICON_UNDO: 15,
  FRAME_X: 16,
  FRAME_X_FOCUSED: 17
};
spritesheetRegister(module.exports);
